import { useMemo } from 'react';

import { STATIC_NAVBAR_SCREEN_OPTIONS, type ScreenOptionsMap } from '../../../../constants';
import { useRouteTitles } from '../../../messages';

/**
 * Screen options for the menu tab layout.
 */
export const useMenuTabStackOptions = () => {
  const titles = useRouteTitles();

  return useMemo(() => {
    return {
      //
      // ─── Main Stack Options (applied to all screens) ─────────────────────

      Stack: STATIC_NAVBAR_SCREEN_OPTIONS,

      // ─── Individual Tabs ─────────────────────────────────────────────────

      Locations: {
        title: titles.locationsTitle,
        customDocumentTitle: titles.locationsCustomDocumentTitle,
        navbarLayout: 'static-with-border',
      },
    } satisfies ScreenOptionsMap;
  }, [titles]);
};
